const getters = {
  getMenuList: (state) => state.menu.menuList, // 获取菜单数据 
  menuDetailList: (state) => state.menu.menuDetailList, // 菜单全部信息列表 
  getIsView: (state) => state.menu.isView, // 获取是否折叠菜单
  getIsAction: (state) => state.menu.isAction, // 获取工作台高亮
}
export default getters